<template>
    <img src="/images/promo/connect-features/moai.png"
     alt="Moai" />
</template>

<script>
export default {};
</script>
